// ABOUTME: Cell renderer of a workflow status column: the state as the chip of its workflow (label, color, icon).
// ABOUTME: Registered for `select` cells too, since some nodes store their status as one; other select cells keep the default.

import { Box } from '@ds/coolshop';
import type { CustomCellRendererProps, NodeContentValueO } from '@ds/data-table';
import { WorkflowStateChip } from '@src/_new/modules/workflow';
import type { ReactElement } from 'react';

import { isWorkflowStatusColumn, workflowOfColumn } from '../asWorkflowStatusGridContentType';

export default function GridCellWorkflowStatusRender(props: CustomCellRendererProps) {
    const { value, ct, contexts, DefaultRenderer } = props;

    if (!isWorkflowStatusColumn(ct)) {
        // Called, not mounted: the package creates `DefaultRenderer` anew on every render, so
        // mounting it would remount every other select cell, and its inline editor, each time.
        return (DefaultRenderer as () => ReactElement)();
    }

    const entries = value as NodeContentValueO[] | undefined;
    const entry =
        entries?.find(e => e.languageIsoCode === contexts.language.defaultLanguage) ?? entries?.[0];
    const stateCode = String(entry?.value?.[0] ?? '');
    if (!stateCode) return null;

    // A code the workflow does not define (a legacy one such as `converted`, or any code when the
    // workflow could not be loaded) gets a plain chip, with no color and icon, labelled the way the
    // widgets label it: its `workflow.state.<code>` message, else the code itself.
    // The cell stretches its child to the column width: the box keeps the chip as wide as its label.
    return (
        <Box display="flex">
            <WorkflowStateChip workflow={workflowOfColumn(ct)} stateCode={stateCode} />
        </Box>
    );
}
